export default __webpack_public_path__ + "static/media/s4_female.f61b53ff.wav";